import { Cell } from '../../components'
import UserLink from './UserLink'
import {
  niceIso8601Time,
  withRouter,
} from '../../shared'

const ItemReportCell = ({report}) =>
  <Cell>
    <Cell.Body>
      <Cell.Line>
        <div>{JSON.parse(report.metadata).reason}</div>
        <div>{report.reviewed ? '●' : '○'}</div>
        <UserLink user_id={report.user_id} />
        <div>{niceIso8601Time(report.created_date)}</div>
      </Cell.Line>
      <Cell.Line>
        <div>{JSON.parse(report.metadata).description}</div>
      </Cell.Line>
    </Cell.Body>
  </Cell>

export default withRouter(ItemReportCell)
